const Amber = {
  Amber: {
    _000: '#FFFBEB',
    _100: '#FEF3C7',
    _200: '#FDE68A',
    _300: '#FCD34D',
    _400: '#FBBF24',
    _500: '#F59E0B',
    _600: '#D97706',
    _700: '#B45309',
    _800: '#92400E',
    _900: '#78350F',
  },
};

export default Amber;
